import {
  getDefaultRpcRequestHeaders,
  setRpcRequestHeadersProvider,
} from '@repo/rpc-codegen/interceptors'
import { getWorkspaceId } from './hooks/use-workspace-query'

export function registerWorkspaceRequestHeaders() {
  setRpcRequestHeadersProvider(() => {
    const teamId = getWorkspaceId()
    return teamId ? { 'x-team-id': teamId } : undefined
  })
}

/**
 * True when the current workspace is a team, so default RPC calls send
 * `x-team-id`. Those calls spend team coins and do not skip-activate a
 * personal trial. This is not "the user belongs to a team."
 */
export function isRequestForTeamWorkspace(): boolean {
  return Boolean(getDefaultRpcRequestHeaders().get('x-team-id'))
}
